import { getApiLoading } from './../helpers/types'

export const getLoading = (state, type) =>
	state.loading[getApiLoading(type)];
